import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { HelpCircleIcon } from "../Icons/SvgIcon";

const TooltipIcon = ({ title, iconWidth = "16", iconHeight = "16", inline = false }) => {
  const tooltipSx = {
    backgroundColor: '#fff',
    color: '#000',
    fontSize: '14px',
    boxShadow: '0px 2px 8px rgba(0, 0, 0, 0.15)',
  };

  return (
    <Tooltip
      title={title}
      slotProps={{
        tooltip: { sx: tooltipSx },
      }}
    >
      {inline ? (
        <span style={{ display: "inline-block", cursor: "help" }}>
          <HelpCircleIcon width={iconWidth} height={iconHeight} />
        </span>
      ) : (
        <button className="analytics-kpi-card__tooltip-btn">
          <HelpCircleIcon width={iconWidth} height={iconHeight} />
        </button>
      )}
    </Tooltip>
  );
};

export default TooltipIcon;
